// Canonical tool-name helpers for the console's approval surfaces.
//
// **Canonical tool-name normalizer.** Live MCP gates fire FEDERATED: the
// create gate arrives as `smokeball___create_contact`, not
// `create_contact` (fn-68; memory
// `project_hitl_federated_mcp_toolname_mismatch`). So every
// classification runs on the BARE name = the segment after the last
// `___`. Custom tools (`review_matter`, `ask_user_question`) are already
// bare and pass through unchanged.
//
// The per-mode approval policy (`decide`, `RESTRICTED_FORM_TOOLS`) that
// used to live here was deleted with the Archie headless page — it was
// that unattended driver's risk routing and had no other consumer.

/** Canonical elicitation tool name (matches `@sb-ai-platform/hitl`). */
export const ASK_USER_QUESTION_TOOL = 'ask_user_question';

/**
 * The bare tool name = the segment after the LAST `___`. Federated MCP
 * tools arrive namespaced (`smokeball___create_contact`,
 * `mattertypes___find_matter_types`); custom + already-bare tools pass
 * through unchanged. Defensive against empty/garbage input.
 */
export function bareToolName(name: string): string {
  if (typeof name !== 'string' || name.length === 0) {
    return '';
  }
  const segments = name.split('___');
  return segments[segments.length - 1] ?? '';
}
